module.exports = __webpack_public_path__ + "img/project-03-01.66b032aa.png";